module.exports = __webpack_public_path__ + "img/1557614105308766210.b84c1ea3.png";